<div *ngIf="isOpen"
  class="fixed inset-0 bg-black/60 flex justify-center items-center z-50"
  (click)="close.emit()">
  <div
    class="bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 p-6 rounded-lg shadow-2xl w-full max-w-7xl relative"
    (click)="$event.stopPropagation()">
    <h3 class="text-xl font-bold mb-4">Knowledge graph</h3>

    <div class="h-[70vh] w-full border border-gray-200 dark:border-gray-800 rounded-md bg-white dark:bg-gray-900 relative graph-container overflow-hidden">
      <div *ngIf="isLoading" class="flex items-center justify-center h-full text-gray-500 dark:text-gray-400">
        Loading graph...
      </div>

      <!-- Foblex flow canvas -->
      <f-flow *ngIf="!isLoading" 
              class="w-full h-full" 
              fDraggable
              (fDragStarted)="onDragStarted()"
              (fDragEnded)="onDragEnded()">
        <f-background></f-background>

        <f-canvas [fZoom]="true">

          <!-- Edges -->
          <f-connection
            *ngFor="let edge of graphEdges"
            [fConnectionId]="edge.id"
            [fOutputId]="edge.source + '_out'"
            [fInputId]="edge.target + '_in'"
            fType="bezier"
            [fReassignDisabled]="true"
            (click)="onEdgeClick(edge)">
            <div fConnectionContent [offset]="0.5" class="edge-label">
              {{ edge.label }}
            </div>
          </f-connection>

          <!-- Nodes -->
          <div
            *ngFor="let node of positionedNodes"
            fNode
            fDragHandle
            [fNodeId]="node.id"
            [fNodePosition]="node.pos"
            [fNodeDraggingDisabled]="false"
            class="graph-node"
            [style.background]="node.displayColor"
            [style.border-color]="node.displayStroke"
            (click)="onNodeClick(node)">

            
            <!-- Output connector (bottom-centre) -->
            <div
              fNodeOutput
              [fOutputId]="node.id + '_out'"
              fOutputConnectableSide="bottom"
              class="connector-dot connector-bottom">
            </div>

            <!-- Node text (Type + Content) -->
            <div class="node-text">
              <span class="node-type">{{ node.displayType }}: </span>
              <span class="node-content">{{ node.displayContent }}</span>
            </div>

            <!-- Input connector (top-centre) -->
            <div
              fNodeInput
              [fInputId]="node.id + '_in'"
              fInputConnectableSide="top"
              [fInputMultiple]="true"
              class="connector-dot connector-top">
            </div>
          </div>

        </f-canvas>
      </f-flow>

      <!-- Legend -->
      <div *ngIf="!isLoading" class="absolute bottom-4 right-4 bg-white dark:bg-gray-800 p-2 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 z-10">
        <div class="space-y-1">
           <div class="flex items-center gap-1.5">
             <span class="w-2.5 h-2.5 rounded-full border border-gray-400 dark:border-gray-500" style="background-color: #FBBF24;"></span>
             <span class="text-xs text-gray-700 dark:text-gray-300">Entity Relationships</span>
           </div>
           <div class="flex items-center gap-1.5">
             <span class="w-2.5 h-2.5 rounded-full border border-gray-400 dark:border-gray-500" style="background-color: #34D399;"></span>
             <span class="text-xs text-gray-700 dark:text-gray-300">Summarization</span>
           </div>
           <div class="flex items-center gap-1.5">
             <span class="w-2.5 h-2.5 rounded-full border border-gray-400 dark:border-gray-500" style="background-color: #60A5FA;"></span>
             <span class="text-xs text-gray-700 dark:text-gray-300">Lineage</span>
           </div>
        </div>
      </div>

      <!-- Detail Sidebar -->
      <app-node-details-sidebar
        [node]="selectedNode"
        (close)="detailsClose.emit()"
        (suggestChunkEdits)="suggestChunkEdits.emit($event)"
        (editChunksDirectly)="editChunksDirectly.emit($event)">
      </app-node-details-sidebar>

      <!-- Edge Detail Sidebar -->
      <app-edge-details-sidebar
        [edge]="selectedEdge"
        (close)="edgeDetailsClose.emit()">
      </app-edge-details-sidebar>
    </div>

    <button
      (click)="close.emit()"
      class="mt-4 bg-gray-600 dark:bg-gray-700 text-white px-4 py-2 rounded-lg hover:bg-gray-700 dark:hover:bg-gray-600">
      Close
    </button>
  </div>
</div>
